import { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import { EMAIL } from '../constants/site'
import { tick } from '../lib/sound'

const field =
  'mt-1 w-full border-stroke border-line bg-paper px-3 py-2 font-hand text-[1.25rem] text-coal placeholder:text-coal/55'

// EmailJS sends straight from the browser. Field names (user_name, user_email, message)
// must match the EmailJS template. Keys come from .env (VITE_SERVICE_ID, VITE_TEMPLATE_ID, VITE_PUBLIC_KEY).
const EmailForm = () => {
  const form = useRef(null)
  const [status, setStatus] = useState('idle') // idle | sending | sent | error

  const send = async (e) => {
    e.preventDefault()
    setStatus('sending')
    try {
      await emailjs.sendForm(
        import.meta.env.VITE_SERVICE_ID,
        import.meta.env.VITE_TEMPLATE_ID,
        form.current,
        {
          publicKey: import.meta.env.VITE_PUBLIC_KEY,
        },
      )
      form.current.reset()
      setStatus('sent')
      tick(1200)
    } catch {
      setStatus('error')
    }
  }

  return (
    <form ref={form} onSubmit={send} className='panel flex flex-col gap-4 p-5 pt-14 md:p-8 md:pt-16'>
      <p className='caption absolute left-0 top-0'>Write to me</p>

      <label className='lettering block text-[1.25rem]'>
        Name
        <input name='user_name' type='text' autoComplete='name' required className={field} />
      </label>
      <label className='lettering block text-[1.25rem]'>
        Email
        <input name='user_email' type='email' autoComplete='email' required className={field} />
      </label>
      <label className='lettering block text-[1.25rem]'>
        Your project
        <textarea
          name='message'
          rows={5}
          required
          placeholder='A Figma file, a link to your site, or a few lines about the idea'
          className={`${field} resize-y`}
        />
      </label>

      <div className='flex flex-wrap items-center gap-4'>
        <button
          type='submit'
          disabled={status === 'sending'}
          className='btn-signal text-[1.25rem] disabled:opacity-60'
        >
          {status === 'sending' ? 'Sending…' : 'Send message'}
        </button>
        <p aria-live='polite' className='text-body'>
          {status === 'sent' && 'Thanks! I’ll reply within a few hours.'}
          {status === 'error' && (
            <>
              That didn&apos;t send. Email me at{' '}
              <a href={`mailto:${EMAIL}`} className='underline underline-offset-4'>
                {EMAIL}
              </a>{' '}
              instead.
            </>
          )}
        </p>
      </div>
    </form>
  )
}

export default EmailForm
